/* Copyright (c) 2021 Caring Transitions Online Auctions. All Rights Reserved. */

// library imports
import { Component } from "react";
// import { Link } from 'react-router-dom';
import { Button, Spinner, Modal, Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import Table from 'react-bootstrap/Table';
import moment from 'moment';
import * as momentTz from 'moment-timezone';
// project imports
import { getSellerUrl, getSellerHeaders, getBuyerHeaders, getBuyerUrl } from 'shared/http';
import store from 'features/store';
import { messagelist, secret_key, itemsNoteCount, messageUpdate, messageReply, messageBulkUpdate, messageDetail, messageDt } from 'shared/settings/apiconfig';
import axios from 'axios';
import toast from 'shared/toast';
import { ToasterMessage } from 'shared/toast/toast';
import Notes from './Notes';
import Validators from 'shared/validators';
import Switch from "react-switch";

// style imports
import './ItemsView.scss'
import { itemdetail, salesDashboard, token, bid_history,bid_history_closedItem, SaledDahboardgenerateInvoice, bidRetract, bidRetractAll, bidders_list, bidRetractSelected, saledetail } from "shared/settings/apiconfig";
import ChangeBidder from "./ChangeBidder"
import { NoData } from "features/components/redirect/NoData";
/**
 * this page is used to view item details
 * 
 * @param props
 * 
 * @return Item view html
 * 
**/

class ItemsView extends Component {
    retractId;
    replyinitialize;

    constructor(props) {
        super(props);

        this.replyinitialize = { value: '', error: '', valid: false, validators: [Validators.required()] };
        this.state = {
            params: this.props.itemsId ? this.props : this.props.match.params,
            loading: false,
            additionalnotes: '',
            retractnotes: '',
            itemsDetails: {},
            modal: false,
            messageList: [],
            replyMessage: { ...this.replyinitialize },
            replyModal: -1,
            options: {
                chart: {
                    plotBackgroundColor: null,
                    plotBorderWidth: null,
                    plotShadow: false,
                    type: 'pie',
                    marginTop: 0
                },
                title: {
                    text: ''
                },
                tooltip: {
                    pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
                },
                accessibility: {
                    point: {
                        valueSuffix: '%'
                    }
                },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '{point.percentage: f} %'
                        },
                        showInLegend: true
                    }
                },
                credits: {
                    enabled: false
                },
                series: [{
                    name: 'Brands',
                    colorByPoint: true,
                    data: [
                        {
                            name: 'John Johnson',
                            y: 80,
                            color: "#97dacd"
                        },
                        {
                            name: 'Peter Hein',
                            y: 12,
                            color: "#9d2543"
                        },
                        {
                            name: 'Nelson Janathan',
                            y: 8,
                            color: "#ff8d8d"
                        }
                    ]
                }]
            },
            error: false,
            pageLoading: true,
            bidderCount: 0,
            bid_history: [],
            biddersList: [],
            currentBid: 0,
            changeBidderModal: false,
            buyerToken: "",
            retractAllModal: false,
            retractModal: false,
            retractStatus: { show: false, type: '', message: '' },
            disabledChangeBidder: true,
            secretKey: "",
            windowWidth:window.innerWidth,
            selectedMessage: [],
            deleting: false,
            selectedRetractModal: false,
            nicknameList: [],
            selectedRetractList: [],
            selectedretractModal: false,
            selectedNickname: [],
            selectedRetract: [],
            isitemRetracted: true,
            SaleStatus: false, // based on that retract button enable or disable
            notesCount: false,
            replyMessageList: '',
            viewMessage: false,
            errorpageredirect: false,
            errorType: ''
        }
        this.retractId = '';
        this.approveBack = false;
    }

    // Hide sidebar 
    componentDidMount() {
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
        this.getSecretKey();
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener('popstate', this.onBack);
        window.addEventListener('resize', this.getwindowwidth);
        this.getMessageList();

    }
    componentDidUpdate() {
        store.dispatch({ type: 'SET_SIDEBAR', payload: false });
    }
    getSecretKey(){
        this.setState({ pageLoading: true });
        axios.get(getSellerUrl(`${secret_key}`),getSellerHeaders()).then(
            response => {
                if (response.data.status.toLowerCase() === 'success') {
                    this.setState({
                        buyerToken: response.data.accessToken
                    }, () => {
                        Promise.all([this.getItemsDetails(), this.getSaleDetail(), this.getNotesCount()]).then(responses => {
                            this.setState({
                                itemsDetails: responses[0]
                            },()=>{
                                this.getBidHistory(this.state.buyerToken)
                              
                            })
                        })
                        this.setState({
                            pageLoading: false
                        })
                        // this.getItemsDetails();
                        // this.getItemMessages();
                        // this.getSaleDetail();
                        // this.getNotesCount()
                        // this.getbidders(response.data.accessToken)
                    })
                }
            }).catch(
                error => {
                    if(error.response.status == 401 || error.response.status == 404) {
                        this.setState({
                            errorpageredirect: true,
                            errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                        })
                    }
                    this.setState({
                        ...this.state,
                        secretKey:"",
                        error: true,
                        pageLoading: false
                    })
                }
            );
    }
    // getItemMessages = async () => {
    //     this.setState({ pageLoading: true });

    //     const data = {
    //         filter: [
    //             { field: "itemid", value: this.state.params.itemsId, op: '=', join: 'AND' },
    //             { field: "isdeleted", value: 0, op: '=', join: 'AND' }
    //         ]
    //     };
    //     await axios.post(getSellerUrl(messagelist), JSON.stringify(data), getSellerHeaders())
    //         .then(response => {
    //             const messageList = [...response.data.data];

    //             messageList.forEach(message => {
    //                 if (message.messagereply) {
    //                     message['messagereply'] = message['messagereply'].split('#*#');
    //                 } else {
    //                     message['messagereply'] = [];
    //                 }
    //             });
    //             if (messageList.length <= 0) {
    //                 this.setState({
    //                     ...this.state,
    //                     errorpageredirect: true,
    //                 });
    //             }
    //             this.setState({
    //                // pageLoading: false,
    //                 messageList: [...messageList]
    //             });
    //         })
    //         .catch(error => {
    //             this.setState({ pageLoading: false });
    //             toast.error(error?.response?.data['message']);
    //         });
    // };

    saveReply = async (mIndex) => {
        if (this.state.replyMessage.valid) {
            this.setState({ replyLoading: true });
            const data = {
                id: this.state.messageList[mIndex]['id'],
                reply: this.state.replyMessage.value,
                itemid: this.props.match.params.itemsId
            };
            await axios.post(getSellerUrl(messageReply), JSON.stringify({ data: data }), getSellerHeaders())
                .then(response => {
                    // const messageList = [...this.state.messageList];
                    // messageList[mIndex]['messagereply'].push(data.messagereply);
                    // this.setState({ messageList: messageList });
                    toast.success('Replied to message');
                    this.onReplyBoxCancel();
                    this.getItemMessages();
                    this.setState({ replyLoading: false });

                    if (this.state.replyNavigate) {
                        this.props.history.push({ pathname: '/messages', state: this.props.location.state });
                    }
                })
                .catch(error => {
                    this.setState({ replyLoading: false });
                    toast.error(error?.response?.data['message']);
                });
        }
    };


    // Show sidebar when leave sales dashboard
    componentWillUnmount() {
        store.dispatch({ type: 'SET_SIDEBAR', payload: true });
        window.removeEventListener('resize', this.getwindowwidth);

    }
    getwindowwidth = () => {
        this.setState({
            windowWidth: window.innerWidth
        });
    }
    getBidToken() {
        var data = {
            "data": {
                "app_identifier": "ctbids_seller",
                "app_secret": "SGFwcHkgU3VuZEB5IG1lYWxzIHg2QVRPUk5KVlpXZQ=="
            }
        }
        axios.post(getBuyerUrl(`${token}`), JSON.stringify(data), getBuyerHeaders()).then(
            resp => {
                this.setState({
                    buyerToken: resp.data.accessToken
                }, () => {
                    this.getBidHistory(resp.data.accessToken)
                    // this.getbidders(resp.data.accessToken)
                })
            }
        ).catch(
            error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                })
            }
        );
    }

    // input change
    onInputChange = (event) => {
        const validatedForm = Validators.formValidation({ replyMessage: this.state.replyMessage }, event);

        this.setState({
            replyMessage: validatedForm['formControls']['replyMessage']
        });
    };

    // Notes Icon count method
    getNotesCount = () => {
        let item_id = this.state.params.itemsId
        let payload = {
            'id': Number(item_id)
        }
        return new Promise((resolve, reject) => {
            axios.post(getSellerUrl(itemsNoteCount), JSON.stringify({ data: payload }), getSellerHeaders()).then(response => {
                let notesResponse = response.data.data[0]
                if (notesResponse) {
                    this.setState({
                        notesCount: notesResponse?.INOT_Count > 0 ? true : false
                    })
                }
                else {
                    this.setState({
                        notesCount: false
                    })
                }
                resolve(notesResponse);
            }).catch(error => {
                reject(error);
                this.setState({
                    loading: false,
                    notesCount: false
                });
            });
        })
    }

    getBidHistory=async(token)=> {
        let url = null;
        if(this.state.itemsDetails.itemstatus === "Ready"){
            url = bid_history;
        }
        else if(this.state.itemsDetails.itemstatus === "Sold" || this.state.itemsDetails.itemstatus === "Not Sold"){
            url = bid_history_closedItem;
        }
        if(url != null) {
            await axios.get(getBuyerUrl(`${url}/${this.state.params.itemsId}`), getBuyerHeaders(token)).then(
                response => {
                    if (response.data.data.bidhistory.length > 0) {
                        this.setState({
                            pageLoading: false,
                            bidderCount: Array.from(new Set(response.data.data.bidhistory.map(elem => elem['buyerid']))).length,
                            bid_history: response.data.data.bidhistory,
                            currentBid: response.data.data.bidhistory[0]["bidprice"],
                         },()=> {
                            this.getNickname()
                        })                  
                    }
                    else {
                        this.setState({
                            pageLoading: false,
                            bidderCount: 0,
                            bid_history: [],
                            currentBid: 0,
                        });
                    }
                }
            ).catch(
                error => {
                    // toast.error(error.response.data['message']);
                    this.setState({
                        ...this.state,
                        bidderCount: 0,
                        bid_history: [],
                        currentBid: 0,
                        pageLoading: false,
                    })
                }
            );
        } 
    }

    getItemMessages = () => {

        const data = {
            filter: [
                // { field: "itemid", value: parseInt(this.state.params.itemsId), op: '=', join: 'AND' },
                // // { field: "isdeleted", value: 0, op: '=', join: 'AND' }
            ]
        };

        return new Promise((resolve, reject) => {
            axios.post(getSellerUrl(`${messageDt}`), data, getSellerHeaders())
                .then(response => {
                    const messageList = [...response.data.data];

                    messageList.forEach(message => {
                        if (message.reply.length > 0) {
                            message['reply'] = message['reply']
                        } else {
                            message['reply'] = [];
                        }
                    });
                    if (messageList.length <= 0) {
                        this.setState({
                            ...this.state,
                            errorpageredirect: true,
                            errorType: 'noData'
                        });
                        return;
                    }
                    this.setState({
                        messageList: [...messageList]
                    });
                    resolve(messageList);
                })
                .catch(error => {
                    toast.error(error?.response?.data['message']);
                    reject(error);
                });
            }
        )
    };

    // saveReply = async (mIndex) => {
    //     if (this.state.replyMessage.valid) {
    //         this.setState({ replyLoading: true });
    //         const data = {
    //             messageid: this.state.messageList[mIndex]['id'],
    //             messagereply: this.state.replyMessage.value
    //         };
    //         await axios.post(getSellerUrl(messagereplyadd), JSON.stringify({ data: data }), getSellerHeaders())
    //             .then(response => {
    //                 const messageList = [...this.state.messageList];
    //                 messageList[mIndex]['messagereply'].push(data.messagereply);
    //                 this.setState({ messageList: messageList });
    //                 toast.success('Replied to message');
    //                 this.onReplyBoxCancel();
    //                 this.setState({ replyLoading: false });

    //                 if (this.state.replyNavigate) {
    //                     this.props.history.push({ pathname: '/messages', state: this.props.location.state });
    //                 }
    //             })
    //             .catch(error => {
    //                 this.setState({ replyLoading: false });
    //                 toast.error(error?.response?.data['message']);
    //             });
    //     }
    // };

    getbidders(token) {
        axios.get(getBuyerUrl(`${bidders_list}${this.state.params.itemsId}`), getBuyerHeaders(token)).then(
            response => {
                if (response.data.status === 'success') {
                    this.setState({
                        ...this.state,
                        disabledChangeBidder: false,
                        biddersList: response.data.data
                    })
                }
                else {
                    this.setState({
                        ...this.state,
                        disabledChangeBidder: true,
                    })
                }
            }).catch(
                error => {
                    this.setState({
                        ...this.state,
                        disabledChangeBidder: true,
                    },()=> {
                        console?.clear()
                    })
                }
            );
    }
    // input change
    onInputChange = (event) => {
        const validatedForm = Validators.formValidation({ replyMessage: this.state.replyMessage }, event);

        this.setState({
            replyMessage: validatedForm['formControls']['replyMessage']
        });
    };

    /* Getting items details */
    getItemsDetails = () => {
        return new Promise((resolve, reject) => {
            axios.get(getSellerUrl(`${itemdetail}/${this.state.params.itemsId}`), getSellerHeaders()).then(
                response => {
                    
                    resolve(response.data.data[0]);
                }
            ).catch(
                error => {
                    if(error.response.status == 401 || error.response.status == 404) {
                        this.setState({
                            errorpageredirect: true,
                            errorType: error.response.status == 401 ? 'expiryError' : error.response.status == 404 ? 'noData' : ''
                        })
                    }
                    this.setState({
                        ...this.state,
                        error: true
                    }, () => {
                        reject(error);
                    })
                }
            );
        });
    }

    // opens reply box
    onReplyBoxShow = (index) => {
        this.setState({
            replyBox: index,
            replyMessage: { ...this.replyinitialize },
            replyNavigate: false
        });
    };
    // closes reply box
    onReplyBoxCancel = () => {
        this.setState({ replyBox: -1 });
    };
    // closes modal box
    onModalAction = (index) => {
        this.setState({ replyModal: index });
    };
    /* Converting date into required format */
    dateFormat = (date) => {
        if (date) {
            return moment.utc(date).local().format('MM/DD/YYYY hh:mm A');
        }
        return '- - -';
    }
    dateFormatCloseTime = (date) => {
        let newdate = moment.tz(date, date).local();
        return `${newdate.format('MM/DD/YYYY hh:mm A')} ${momentTz.tz(momentTz.tz.guess()).zoneAbbr()}`;
    }
    /* called when note clicked */
    viewNotes = () => {
        this.setState({
            ...this.state,
            modal: true
        });
    }

    /* called when save or note closed */
    hideNotes = () => {
        this.setState({
            ...this.state,
            modal: false
        })
    }

    /* Calculating shipping and handling fee */
    shippingfeeAndHandlingfee = () => {
        const shippingfee = this.state.itemsDetails.shippingfee ? this.state.itemsDetails.shippingfee : 0;
        const handlingfee = this.state.itemsDetails.handlingfee ? this.state.itemsDetails.handlingfee : 0;
        const returnVal = parseFloat(shippingfee + handlingfee).toFixed(2);
        return returnVal;
    }

    /* Converting value to decimal */
    convertingToDecimal = (value, len = 2) => {
        const check = value ? value : 0;
        return parseFloat(check).toFixed(len);
    }
    /* convert utc  local time */
    convertLocalTime(date) {
        return moment(moment.utc(date)).local().format('MM/DD/YYYY hh:mm:ss A');
    }
    getTimeZone = () => {
        const timeZone = momentTz.tz.guess();
        return momentTz.tz(timeZone).zoneAbbr();
    }

    generateInvoice() {

        var data = {
            "data": {

                "buyerid": [{
                    "itemid": this.state.params.itemsId,

                    "description": this.state.itemsDetails.description,

                    "amount": this.state.itemsDetails.buynowprice,

                    "tax": this.state.itemsDetails.tax,
                }]
            }
        }
        axios.post(getSellerUrl(`${SaledDahboardgenerateInvoice}/:${this.state.itemsDetails.saleid}`), JSON.stringify(data), getSellerHeaders()).then(
            resp => {
            }
        ).catch(
            error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    ...this.state,
                })
            }
        );
    }
    // opens reply box
    onReplyBoxShow = (index) => {
        this.setState({
            replyBox: index,
            replyMessage: { ...this.replyinitialize },
            replyNavigate: false
        });
    };
    // closes reply box
    onReplyBoxCancel = () => {
        this.setState({ replyBox: -1 });
    };
    // closes modal box
    onModalAction = (index) => {
        this.setState({ replyModal: index });
    };
    retract(index) {
        this.setState({ loading: true });
        var data = {
            "data": {
                "itemid": this.state.params.itemsId,
                "bidid": index,
                "revokedreason": this.state.retractnotes,
            }
        }
        axios.post(getBuyerUrl(`${bidRetract}`), JSON.stringify(data), getBuyerHeaders(this.state.buyerToken)).then(
            resp => {
                this.setState({
                    ...this.state,
                    loading: false,
                    retractStatus: { show: true, type: resp.data.status === 'failed' ? 'danger' : 'success' , message: resp.data.message ? resp.data.message : resp.data.data }
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            retractModal: false,
                            retractnotes: '',
                            retractStatus: { show: false, type:  resp.data.status, message: resp.data.message ? resp.data.message : resp.data.data }
                        }, () => this.getBidHistory(this.state.buyerToken));
                    }, 3000);
                });
            }
        ).catch(
            error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    loading: false,
                    retractStatus: { show: true, type: 'danger', message: error?.response?.data['message'] },
                }, () => this.getBidHistory(this.state.buyerToken));
            }
        );
    }
    // retract all
    retractAll() {
        this.setState({ loading: true })
        var data = {
            "data": {
                "itemid": this.state.params.itemsId,
                "revokedreason": this.state.additionalnotes,
            }
        }
        axios.post(getBuyerUrl(`${bidRetractAll}`), JSON.stringify(data), getBuyerHeaders(this.state.buyerToken)).then(
            resp => {                
                this.setState({
                    ...this.state,
                    loading: false,
                    retractStatus: { show: true, type: resp.data.status === 'failed' ? 'danger' : 'success', message: resp.data.message ? resp.data.message : resp.data.data }
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            retractAllModal: false,
                            retractStatus: { show: false, type: resp.data.status, message: resp.data.message ? resp.data.message : resp.data.data }
                        }, () => this.getBidHistory(this.state.buyerToken));
                    }, 3000);
                });
                //  toast.success(resp.data.status)
            }
        ).catch(
            error => {
                // toast.error(error.response.data['message']);
                this.setState({
                    loading: false,
                    retractStatus: { show: true, type: 'danger', message: error?.response?.data['message'] }
                }, () => this.getBidHistory(this.state.buyerToken));
            }
        );
    }
    handleChange = (e) => {
        this.setState({ additionalnotes: e.target.value })
    }

    handleRetractChange = (e) => {
        this.setState({ retractnotes: e.target.value })
    }
    showRetractModal = (id) => {
        this.retractId = id;
        this.setState({
            retractModal: true,
            retractStatus: { show: false, type: '', message: '' }
        });
    }

    showRetractAllModal = () => {
        this.setState({
            retractAllModal: true,
            retractStatus: { show: false, type: '', message: '' }
        });
    }

    // Selected Retract Nickname without Duplicates 
    getNickname() {
        const BidderValues = this.state.bid_history.map(item => { return { id: item.buyerid, nickname: item.nickname } })
        const ids = BidderValues.map(o => o.id)
        const filtered = BidderValues.filter(({ id }, index) => !ids.includes(id, index + 1))
        const filteredBidderValues = filtered.sort((a, b) => (a.id > b.id) ? 1 : -1)
        this.setState({
            nicknameList: filteredBidderValues,  
        })
    }

    // Selected Retract Modal Open Handling
    showselectedRetractModal = () => {
        this.setState({
            selectedRetractModal: true,
            retractStatus: { show: false, type: '', message: '' }
        });
    }

    // Selected Retract Modal Close Handling
    resetselectedRetractModal = () => {
        this.setState({
            selectedRetractModal: false,
            selectedNickname: [],
            selectedRetractList: [],
            retractStatus: { show: false, type: '', message: '' }
        });
    }

    // Handle Selected Checkbox Values
     onChangeRetractCheckBox(value) {
        let selectedNickname = [];
        let selectedRetract = [];
        let index = selectedNickname.indexOf(value.id);
        if (index >= 0) {
            selectedNickname.splice(index, 1);
            selectedRetract.splice(index,1)
        }
        else {
            selectedNickname.push(value.id);
            selectedRetract.push(value);
        }
        this.setState({
            selectedNickname,
            selectedRetractList: selectedRetract
        })
    }

    // selected retract Modal
    showSelectedReasonModal = () => {
        this.setState({
            selectedRetractModal: false,
            selectedNickname: [],
            selectedretractModal: true,
            retractStatus: { show: false, type: '', message: '' }
        });
    }
    // selected buyer bid retract api call
    Selectedretract (Buyer) {
        let BuyerId = Buyer[0].id
        this.setState({ loading: true });
        var data = {
            "data": {
                "itemid": this.state.params.itemsId,
                "buyerid": BuyerId,
                "revokedreason": this.state.retractnotes,
            }
        }
        axios.post(getBuyerUrl(`${bidRetractSelected}`), JSON.stringify(data), getBuyerHeaders(this.state.buyerToken)).then(
            resp => {
                this.setState({
                    ...this.state,
                    loading: false,
                    retractStatus: { show: true, type: resp.data.status === 'failed' ? 'danger' : 'success', message: resp.data.message ? resp.data.message : resp.data.data }
                }, () => {
                    setTimeout(() => {
                        this.setState({
                            selectedretractModal: false,
                            retractnotes: '',
                            retractStatus: { show: false, type: '', message: resp.data.message ? resp.data.message : resp.data.data }
                        }, () => this.getBidHistory(this.state.buyerToken));
                    }, 3000);
                });
            }
        ).catch(
            error => {
                this.setState({
                    loading: false,
                    retractStatus: { show: true, type: 'danger', message: error?.response?.data['message'] },
                }, () => this.getBidHistory(this.state.buyerToken));
            }
        );
    }

    // to get Sale details
    getSaleDetail = () => {
        let field = ['status'];
        return new Promise((resolve, reject) => {
            axios.post(getSellerUrl(`${saledetail}/${this.props.match.params.salesId}`), JSON.stringify({ field: field }), getSellerHeaders())
                .then((response) => {
                    if (response.status === 200) {
                        response = response.data.data[0];
                        this.setState({
                            SaleStatus: response.status === 'Closed'
                        })
                    }
                    resolve(response)
                })
                .catch((error) => {
                    reject(error);
                });
        })  
    };

    buyerDetail = (buyerid) => {
        // let buyerData = this.state.biddersList.filter(x => x.nickname === name)[0];
        this.props.history.push({ pathname: `/buyer/edit/${buyerid}`, state: { prevPath: this.props?.match?.url, saletitle: this.props?.location?.state?.saletitle } })
    }

    onBack = (e) => {
        e.preventDefault();
        if (this.approveBack) {
            window.removeEventListener('popstate', this.onBack);
        } else {
            this.approveBack = true;
            this.navigateToList();
            // this.props.history.goBack();
        }
    }

    navigateToList = () => {
        const state = this.props.location.state;
        if (state)
            delete state['prevPath'];
        this.props.history.push({ pathname: `${salesDashboard}/${this.state.params.salesId}`, state: state ,itemid: this.state.params.itemsId, itemEdit: this.state.isitemRetracted });
    };


    toggleChange = (message, mIndex) => {
        let { messageList } = this.state;
        let isPublic = !messageList[mIndex]['ispublic'];
        messageList[mIndex]['ispublic'] = isPublic
        this.setState({
            messageList
        })

        const data = {
            "id": message.id,
            "ispublic": isPublic ? 1 : 0,
            "itemid": message.itemid,
            "buyerid": message.buyerid,
            
        };
        axios.put(getSellerUrl(messageUpdate), JSON.stringify({ data: data }), getSellerHeaders()).then(
            response => {

            })
            .catch(error => {

            });
    }

    selectMessage = (event, data) => {
        event.preventDefault();
        const selectedMessage = this.state.selectedMessage;
        const index = selectedMessage.findIndex(x => x.id === data.id);
        if (index !== -1) {
            selectedMessage.splice(index, 1);
        } else {
            selectedMessage.push(data);
        }
        this.setState({
            selectedMessage
        });
    }
   
    isMessageSelected = (data) => {
        return this.state.selectedMessage.findIndex(x => x.id === data.id) > -1;
    }

    isAllSelected = () => {
        var unDeletedMessageList = this.state.messageList.filter((elem) => { return elem.isdeleted == 0 });
        var unDeletedSelectedList = this.state.selectedMessage.filter(elem => { return elem.isdeleted == 0; });
        return unDeletedMessageList.length > 0 && unDeletedSelectedList.length > 0 && unDeletedMessageList.length === unDeletedSelectedList.length;
    }

    toggleSelectAll = (event) => {
        event.preventDefault();
        this.setState({
            selectedMessage: this.isAllSelected() ? [] : JSON.parse(JSON.stringify(this.state.messageList.filter(elem => { return elem.isdeleted == 0; })))
        });
    }

    deleteSelected = () => {
        this.setState({
            deleting: true
        }, async () => {
            const messageList = this.state.selectedMessage.map(x => x.id);
            const data = { "ids": messageList, "isdeleted": 1 };
            await axios.post(getSellerUrl(messageBulkUpdate), JSON.stringify({ data: data }), getSellerHeaders())
                .then(async (response) => {
                    const getMessage = {
                        filter: [
                            { field: "itemid", value: parseInt(this.state.params.itemsId), op: '=', join: 'AND' },
                        ],
                        sort: [{ field: 'createddate', direction: 'desc' }]
                    };
                    await axios.post(getSellerUrl(messagelist), JSON.stringify(getMessage), getSellerHeaders())
                        .then(response => {
                            const messageList = [...response.data.data];
                            messageList.forEach(message => {
                                if (message.reply.length > 0) {
                                    message['reply'] = JSON.parse(message['reply'])
                                } else {
                                    message['reply'] = [];
                                }
                            });
                            this.setState({
                                messageList: messageList,
                                deleting: false,
                                selectedMessage: []
                            });
                        })
                        .catch(error => {
                            this.setState({
                                deleting: false
                            });
                            toast.error(error?.response?.data['message']);
                        });
                })
                .catch(error => {
                    this.setState({
                        deleting: false
                    });
                    toast.error(error?.response?.data['message']);
                });
        });

    }

    getMessageList = () => {
        const getMessage = {
            filter: [
                { field: "itemid", value: parseInt(this.props.match.params.itemsId), op: '=', join: 'AND' },
            ],
            sort: [{ field: 'createddate', direction: 'desc' }]
        };
        axios.post(getSellerUrl(messagelist), JSON.stringify(getMessage), getSellerHeaders())
        .then(response => {
            const messageList = [...response.data.data];
            messageList.forEach(message => {
                if (message.reply) {
                    message['reply'] = message['reply'];
                } else {
                    message['reply'] = [];
                }
            });
            this.setState({
                messageList: messageList,
            });
        })
        .catch(error => {
            this.setState({
                messageList: []
            });
        });
    }

    navigateToMessageList = () => {
        store.dispatch({ type: 'SET_MESSAGE_ITEMID', payload: { setItemId: true, itemId: this.props.match.params.itemsId }});
        this.setState({
            viewMessage: true
        }, () => {
            this.props.history.push({ pathname: `/messages/unread`, itemId: this.props.match.params.itemsId });
        })
    }

    render() {
        if (this.state.errorpageredirect) {
            return <NoData {...this.props} type={this.state.errorType} />
        }
        return (
            <div className="items-main-div" style={{ overflowX: "hidden", overflowY: "auto" }}>
                {
                    this.state.pageLoading && !this.state.error ?
                        <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                            <img src={`${process.env.PUBLIC_URL}/static/icons/table/option_1.gif`} alt="Please wait ....." height="100px" width="100px" />
                        </div> : !this.state.pageLoading && !this.state.error ? <div className="item-responsive">
                            <div className="d-flex flex-column" style={{ width: '99%' }}>
                                <div className="d-flex flex-row align-items-center border-bottom border-outline" style={{ minHeight: '40px' }}>
                                    <div className="d-flex flex-row align-items-center justify-content-center border-right border-outline px-2 h-100">
                                        <span onClick={this.navigateToList} className="clickable">
                                            <i className="fa fa-chevron-circle-left fa-lg text-back rounded-circle"></i>
                                            <span className="ml-2">Back</span>
                                        </span>
                                    </div>
                                    <span onClick={this.navigateToList} className="clickable">
                                        <span className="mx-2">Sales Dashboard |</span>
                                    </span>
                                    {/* <span className="mx-2">Sales Dashboard |</span> */}
                                    <span className="text-secondary">Item View</span>
                                    {/* <div className="buttons-align align-self-end ml-auto" >
                                        {(this.state.itemsDetails.itemstatus === "Sold" && !this.state.disabledChangeBidder && this.state.bid_history.length && (this.state.itemsDetails.reserveprice === null || this.state.itemsDetails.reserveprice === this.state.currentBid || this.state.itemsDetails.reserveprice < this.state.currentBid)) ? <Button
                                            onClick={() => {
                                                this.setState({
                                                    changeBidderModal: true
                                                })
                                            }} variant="secondary">Change Bidder</Button> : ''}
                                    </div> */}
                                </div>
                            </div>
                            <div className="d-md-flex items-min-h">
                                {/* <div className="border items-column-1">
                                    <div className="top-content">
                                        <div className="text-secondary text-bold set-pad-l">Buyers</div>
                                        <div className="set-pad-l first-section">
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                            <div></div>
                                        </div>
                                        <div className="line-break"></div>
                                        <div className="second-section set-pad-l">
                                            Location Suspensions: 0 <br />
                                            Site Suspensions: 0 <br />
                                            Location Amount to Date: $0.00
                                        </div>
                                     </div>
                                   <div className="buttons-align">
                                        {this.state.itemsDetails.itemstatus !== "Sold" && <Button onClick={()=>{this.generateInvoice()}} variant="success" className="mb-6">Generate Invoice</Button>}
                                        <Button onClick={()=>{
                                            this.setState({
                                            changeBidderModal:true
                                        })}} variant="secondary">Change Bidder</Button>
                                    </div>
                                </div> */}
                                <div className="border items-column-2 set-pad-l" style={{ width: this.state.windowWidth < 425 ? (this.state.windowWidth - 30) : "27%", marginLeft: this.state.windowWidth < 425 ? "2%" : "0%" }}>
                                    <div className="item-content">
                                        <div className="item-title">Sale Title</div>
                                        <div className="mb-set">
                                            {this.state.itemsDetails.saletitle}
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">Item Title</div>
                                        <div className="mb-set" style={{wordWrap: "break-word"}}>
                                            {this.state.itemsDetails.title}
                                        </div>
                                    </div>
                                    {this.state.itemsDetails.itemclosetime ?
                                        <div className="item-content">
                                            <div className="item-title">Item Closed Time</div>
                                            <div className="mb-set">
                                                <div>{`${this.dateFormatCloseTime(this.state.itemsDetails.itemclosetime)}`}</div>
                                            </div>
                                        </div>
                                        : ''}
                                    <div className="item-content">
                                        <div className="item-title">Item History</div>
                                        <div className="mb-set">
                                            <div>Status - {this.state.itemsDetails.itemstatus}</div>
                                            <div>{this.state.itemsDetails.updatedby ? this.state.itemsDetails.updatedby : this.state.itemsDetails.createdby}</div>
                                            <div>{this.dateFormat(this.state.itemsDetails.modifieddate)}</div>
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">SKU</div>
                                        <div className="mb-set" style={{wordWrap: "break-word"}}> 
                                            {this.state.itemsDetails.SKU}
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">Area &amp; Category</div>
                                        <div className="mb-set">
                                            <div>{this.state.itemsDetails.area},</div>
                                            <div>{this.state.itemsDetails.category}</div>
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">Length &#10005; Width &#10005; Height &amp; Weight</div>
                                        <div className="mb-set">
                                        {this.state.itemsDetails.length ? this.state.itemsDetails.length : 0}" &#10005; {this.state.itemsDetails.width ? this.state.itemsDetails.width : 0}" &#10005; {this.state.itemsDetails.height ? this.state.itemsDetails.height : 0}" &amp;  {this.state.itemsDetails.weight ? this.state.itemsDetails.weight : 0}lbs
                                        </div>
                                    </div>
                                    <div className="item-content">
                                        <div className="item-title">Item Settings</div>
                                        <div className="mb-set">
                                            <div>Starting: &#36;{this.state.itemsDetails.startingprice ? this.convertingToDecimal(this.state.itemsDetails.startingprice) : this.convertingToDecimal(0)}</div>
                                            <div>Reserve: &#36;{this.state.itemsDetails.reserveprice ? this.convertingToDecimal(this.state.itemsDetails.reserveprice) : this.convertingToDecimal(0)}</div>
                                            <div>Direct: &#36;{this.state.itemsDetails.buynowprice ? this.convertingToDecimal(this.state.itemsDetails.buynowprice) : this.convertingToDecimal(0)}</div>
                                            <div>BP: {this.state.itemsDetails.buyerspremium ? this.convertingToDecimal(this.state.itemsDetails.buyerspremium, 3) : this.convertingToDecimal(0, 3)}%</div>
                                            <div>Tax: {this.state.itemsDetails.tax ? this.convertingToDecimal(this.state.itemsDetails.tax, 3) : this.convertingToDecimal(0, 3)}%</div>
                                            <div>Shipping: &#36;{this.state.itemsDetails.shippingfee ? this.convertingToDecimal(this.state.itemsDetails.shippingfee) : this.convertingToDecimal(0)}</div>
                                            <div>Handling: &#36;{this.state.itemsDetails.handlingfee ? this.convertingToDecimal(this.state.itemsDetails.handlingfee) : this.convertingToDecimal(0)}</div>
                                            {/* <div>S&amp;H: &#36;{this.shippingfeeAndHandlingfee()}</div> */}
                                        </div>
                                        {/* <span><a href={this.state.itemsDetails.tax} target="_blank">{this.state.itemsDetails.tax}</a></span> */}
                                    </div>
                                    {this.state.itemsDetails.itemviewurl?
                                    <div className="item-content">
                                        <div className="item-title">Item Url</div>
                                        <span><a href={this.state.itemsDetails.itemviewurl} target="_blank">{this.state.itemsDetails.itemviewurl}</a></span>
                                    </div>:''}
                                    {/* {this.state.itemsDetails.itemstatus !== "Pending" && <div className="item-content">
                                        <div className="item-title">Invoiced</div>
                                        <div className="mb-set">
                                            &#36;0.00
                                        </div>
                                    </div>}
                                    {this.state.itemsDetails.itemstatus !== "Pending" && <div className="item-content">
                                        <div className="item-title">Paid</div>
                                        <div className="mb-set">
                                            &#36;0.00
                                        </div>
                                    </div>}
                                    {this.state.itemsDetails.itemstatus !== "Pending" && <div className="item-content">
                                        <div className="item-title">Pending</div>
                                        <div className="mb-set">
                                            &#36;0.00
                                    </div>
                                    </div>} */}
                                    <div className="item-content">
                                        <div className="item-title">Notes</div>
                                        <div className="mb-set" style={{ width: 'max-content' }}>
                                        {
                                                this.state.notesCount ?
                                                    <div className="notes-icon-container mt-1">
                                                        {
                                                            this.state.notesCount ?
                                                                <div className="green-icons"></div>
                                                                : null
                                                        }
                                                        <img src={`${process.env.PUBLIC_URL}/static/icons/table/notes.svg`} alt="notes" className="clickable" onClick={this.viewNotes} />
                                                    </div> :
                                                    <img src={`${process.env.PUBLIC_URL}/static/icons/table/notes.svg`} alt="notes" className="clickable" onClick={this.viewNotes} />
                                        }
                                        </div>
                                    </div>
                                </div>
                                <div className="border items-column-4" style={{ width: this.state.windowWidth < 425 ? (this.state.windowWidth - 30) : "40%", marginLeft: this.state.windowWidth < 425 ? "2%" : "0%" }}>
                                    {
                                        this.state.itemsDetails.itemtypeid > 1 ?
                                            <div className="set-pad-l mt-3">
                                                <div className="content-column">
                                                    <div className="item-content">
                                                        <div className="d-flex align-items-center" style={{ justifyContent: "space-between" }}>
                                                            <div className="item-title">Bidding History</div>
                                                            <div></div>
                                                        </div>
                                                        <div className="mb-set"></div>
                                                        {/* <div className="line-break"></div> */}
                                                        <div className="line-break"></div>
                                                        <div className="mb-unset d-flex mt-3" style={{ padding: "2% 4%", justifyContent: "space-around" }}>
                                                            <div className="mx-2">{`Bidders: ${this.state.bidderCount}`}</div>
                                                            <div className="mx-2">{this.state.itemsDetails.itemstatus === "Sold" ? "Sold Price:" : "Current Bid:"} &#36;<span>{this.state.currentBid !== "" ? parseFloat(this.state.currentBid).toFixed(2) : "0.00"}</span></div>
                                                            <div className="mx-2">Goal: &#36;<span>{this.state.itemsDetails.goal !== null ? this.state.itemsDetails.goal : "0.00"}</span>[&#36;<span>{this.state.currentBid !== "" ? parseFloat(this.state.currentBid).toFixed(2): "0.00"}</span>]</div>
                                                            <div className="mx-1">Value: &#36;<span>{this.state.itemsDetails.valuation !== null ? this.state.itemsDetails.valuation : "0.00"}</span>[&#36;<span>{this.state.currentBid !== "" ? parseFloat(this.state.currentBid).toFixed(2) : "0.00"}</span>]</div>
                                                        </div>
                                                    </div>

                                                    {/* <div className="top-bid-history">
                                                        <div className="bid-title">Top Bidders</div>
                                                        {
                                                            this.state.topBidder.map((bidder, id) => (
                                                                <div className="bidder-view" >
                                                                    <div className="bidder-color" style={{ backgroundColor: bidder.color, width: 10, height: 10 }}></div>
                                                                    <div className="bidder-rank">{`${id + 1}st `}</div>
                                                                    <div className="bidder-name">{bidder.name}</div>
                                                                </div>
                                                            ))
                                                        }
                                                    </div> */}
                                                </div>
                                                {/* <div className="chart-column">
                                                    <HighchartsReact highcharts={Highcharts} options={this.state.options} />
                                                </div> */}
                                            </div>
                                            : null
                                    }
                                    {
                                        this.state.itemsDetails.itemtypeid > 1 ?
                                            <div className="line-break"></div>
                                            : null
                                    }
                                    {this.state.bid_history.length ?
                                        <div>

                                            {/* Header and Buttons UI */}
                                            <Table responsive style={{ marginBottom: '0px' }}>
                                            {this.state.bid_history.length ? 
                                             <thead>
                                                <tr>
                                                    <th style={{ color:'#9f2241' }}>Item Details</th>
                                                </tr>
                                                <tr className="d-flex align-items-center justify-content-end table-heading" style={{ border: 'none' }}>
                                                    <th style={{  border: 'none'}}><Button disabled={this.state.itemsDetails.itemstatus != "Ready"} style={{ color: 'white', backgroundColor:'#71c5e8', borderColor:'#71c5e8' }} onClick={() => this.showselectedRetractModal()} className="btn" >Retract a Bidder</Button></th>
                                                    <th style={{  border: 'none'}}><Button disabled={this.state.itemsDetails.itemstatus != "Ready"} style={{ color: 'white', backgroundColor:'#71c5e8', borderColor:'#71c5e8' }} onClick={() => this.showRetractAllModal()} className="btn" >Retract All</Button></th>
                                                </tr>
                                            </thead>: "" }          
                                            </Table>

                                            {/* Main Contenets UI */}
                                            <Table responsive className="bidder-report">
                                                <thead>
                                                    <tr>
                                                        <th style={{width: '20%'}}>Date &amp; Time</th>
                                                        <th>Bidder</th>
                                                        <th>Bid Amount</th>
                                                        <th>Proxy Max Bid</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        this.state.bid_history.map((row, index) => (

                                                            <tr>
                                                                <td>{row['createddate'] !== "" ? this.convertLocalTime(row['createddate']) : "- - -"} {this.getTimeZone()}</td>
                                                                <td className="clickable text-info" onClick={() => this.buyerDetail(row['buyerid'])}>{row['nickname']} { row['membershipCompleted'] ? <img src={`${process.env.PUBLIC_URL}/static/images/membership.png`} alt="" width={'20px'}  />: ''  }</td>
                                                                <td>{row['bidprice']}</td>
                                                                <th>{row['maxproxyprice']}</th>
                                                                <td>{index === 0 && <Button disabled={this.state.itemsDetails.itemstatus != "Ready"} style={{ width: 95 }} onClick={() => this.showRetractModal(row.id)} className="retractButton btn-white" >Retract</Button>}</td>
                                                              </tr>
                                                        ))
                                                        
                                                    }
                                                </tbody>
                                            </Table>
                                        </div>
                                        : <div className="w-100 h-100 d-flex  justify-content-center" style={{ marginTop: "10%", fontSize: "15px" }}>No data available</div>}
                                </div>
                           
                                <div className="border items-column-4" style={{ width: this.state.windowWidth<425?(this.state.windowWidth-30):"40%",marginLeft: this.state.windowWidth < 425? "2%":"0%", height: "616px", overflow: "auto" }}>
                                <div className="communication-column set-pad-l">
                                        <div className="item-content">
                                            <div className="d-flex align-items-center" style={{ justifyContent: "space-between" }}>
                                                {/* <div className="item-title">Messages &amp; Reply</div> */}
                                                <div className='d-flex align-items-center'>
                                                    <Button variant="secondary" className="mr-2" onClick={() => {this.navigateToMessageList()}} disabled={this.state.messageList.length == 0}>  View Messages {this.state.viewMessage ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : ''}</Button>
                                                    {/* <div className={`custom-checkbox-div ${this.isAllSelected() ? 'checked' : ''}`} style={{ opacity: `${this.state.messageList.filter(elem => { return elem.isdeleted == 0; })}` ? "" : '0.3' , pointerEvents: `${this.state.messageList.filter(elem => { return elem.isdeleted == 0; })}` ? "" : 'none' }} onClick={(event) => { event.stopPropagation(); this.toggleSelectAll(event) }}></div>   */}
                                                </div>
                                            </div>   
                                            <div className="mb-set"></div>
                                            <div className="line-break"></div>
                                        </div>
                                        {/* <div className="d-flex flex-column w-100 w-75 h-100 border message-content" style={{ position: "relative" }}>
                                            {
                                                this.state.messageList.length ?
                                                    this.state.messageList.map((message, mIndex) => {
                                                        let ispublic = message.ispublic
                                                        return (
                                                            <div key={mIndex}
                                                                className={`${message['reply'].length ? "bg-grey-light" : "bg-not-replied"} mb-3 mt-3 py-2 px-3`}>
                                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                                    <div style={{ paddingRight: "3%", width: "42%" }}>{ispublic ? "Remove from Public View" : "Allow for Public View"}</div>
                                                                    <Switch checked={ispublic} handleDiameter={15} onChange={() => { this.toggleChange(message, mIndex) }}
                                                                        offColor="#a03741" onColor="#408905" height={25} width={50}
                                                                        uncheckedIcon={
                                                                            <div style={{ display: "flex", alignItems: "center", height: "100%", width: "20px", fontSize: 15, }}>
                                                                            </div>
                                                                        }
                                                                        checkedIcon={
                                                                            <div style={{ display: "flex", alignItems: "center", height: "100%", width: "20px", fontSize: 15, }}>
                                                                            </div>
                                                                        }
                                                                        disabled={message.isdeleted == 1}
                                                                    />
                                                                    <div className="delete-checkbox">
                                                                        <div className={`custom-checkbox-div ${this.isMessageSelected(message) ? 'checked' : ''}`} style={{ opacity: `${message.isdeleted == 1 ? "0.3" : ""}`, pointerEvents: `${message.isdeleted == 1 ? "none" : ""}` }} onClick={message.isdeleted == 1 ? null : (event) => { event.stopPropagation(); this.selectMessage(event, message) }}></div>
                                                                    </div>
                                                                </div>
                                                                <div className="d-flex flex-row justify-content-end">
                                                                    <span className="text-grey-name">{message['membershipCompleted'] ? <img src={`${process.env.PUBLIC_URL}/static/images/membership.png`} alt="" width={'20px'} /> : ''}  {message['createdby']}</span>
                                                                </div>

                                                                <div className="w-100 d-flex flex-row">
                                                                    <b>M:</b>
                                                                    <span className="w-100 ml-1">{message['message']}</span>
                                                                    <span className="" style={{ float: 'right', width: '50%' }}>{moment.utc(message['createddate']).local().format('MM/DD/YYYY hh:mm A')} </span>
                                                                </div>

                                                                {
                                                                    message['reply'].length ?
                                                                        <div className="w-100 d-flex flex-row">
                                                                            <b>R:</b>
                                                                            <span className="w-100 ml-1">{message['reply'][0].reply}</span>
                                                                            <span className="" style={{ float: 'right', width: '50%' }}>{moment.utc(message['reply'][0].createdtime).local().format('MM/DD/YYYY hh:mm A')} </span>
                                                                        </div> :
                                                                        null
                                                                }

                                                                <div className={`w-100 d-flex flex-row ${message['reply'].length > 1 ? "justify-content-between" : "justify-content-end"}`}>
                                                                    {
                                                                        message['reply'].length > 1 ?
                                                                            <span className="text-link clickable" onClick={() => this.onModalAction(mIndex)}>Read all replies</span> :
                                                                            null
                                                                    }
                                                                    {
                                                                        this.state.replyBox === -1 || this.state.replyBox !== mIndex ?
                                                                            <span className={`${message.isdeleted == 1 ? "" : "clickable"}`} style={{ opacity: `${message.isdeleted == 1 ? "0.3" : ""}` }} onClick={message.isdeleted == 1 ? null : () => { this.onReplyBoxShow(mIndex) }}>
                                                                                <i className="fa fa-reply text-grey-name mr-1" />
                                                                                Reply
                                                                            </span> :
                                                                            <div className="d-flex flex-column w-50">
                                                                                <Form.Control as="textarea" placeholder="Reply to message..." rows={3}
                                                                                    name="replyMessage" value={this.state.replyMessage.value}
                                                                                    onChange={this.onInputChange} autoFocus />
                                                                                <div style={{ height: "20px" }}>
                                                                                    {
                                                                                        !this.state.replyMessage.valid ?
                                                                                            <small className="text-danger">{this.state.replyMessage.error}</small> :
                                                                                            null
                                                                                    }
                                                                                </div>
                                                                                <div className="d-flex flex-row justify-content-end my-2">
                                                                                    <Form.Check id="replyNavigate" type="checkbox" label="Reply and navigate to list" value={this.state.replyNavigate}
                                                                                        onChange={this.onReplyNavigate} />
                                                                                </div>
                                                                                <div className="d-flex flex-row justify-content-end">
                                                                                    <Button variant="secondary" className="mr-2" onClick={() => this.saveReply(mIndex)}
                                                                                        disabled={!this.state.replyMessage.valid || this.state.replyLoading}>Reply</Button>
                                                                                    <Button className="bg-white text-dark" onClick={this.onReplyBoxCancel}
                                                                                        disabled={this.state.replyLoading}>Cancel</Button>
                                                                                </div>
                                                                            </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        )
                                                    }) :
                                                    <div className="w-100 h-100 d-flex flex-row align-items-center justify-content-center">
                                                        No messages available
                                                    </div>
                                            }
                                        </div> */}
                                    </div>
                                </div></div>
                        </div> : <div className="d-flex flex-column align-items-center justify-content-center w-100 h-100">
                            <h4>No Data found</h4>
                        </div>
                }
                {/* dialog box to show all replies for a message */}
                <Modal show={this.state.replyModal > -1} size="lg" animation={false} scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <Button type="button" onClick={() => this.onModalAction(-1)} className="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></Button>
                    </Modal.Header>
                    <Modal.Body className="d-flex flex-column align-items-center justify-content-center" >
                        {

                            this.state.replyModal > -1 ?
                                <div className="w-100 d-flex flex-row border py-3 px-2">
                                    <b>M:</b>
                                    <span className="w-100 ml-1">{this.state.messageList[this.state.replyModal]['message']}</span>
                                    <span className="w-100 ml-1">{moment.utc(this.state.messageList[this.state.replyModal]['createddate']).local().format('MM/DD/YYYY hh:mm A')}</span>
                                </div> :
                                null
                        }
                        <div style={{ width: '100%', height: '400px', maxHeight: '80vw' }}>
                            {
                                this.state.replyModal > -1 ?
                                    this.state.messageList[this.state.replyModal]['reply'].map(reply => (
                                        <div className="w-100 d-flex flex-row py-3 px-2" style={{ borderBottom: "1px dashed black" }}>
                                            <b>R:</b>
                                            <span className="w-100 ml-1" style={{ wordBreak: "break-word" }}>{reply.reply}</span>
                                            <span className="w-100 ml-1" style={{ wordBreak: "break-word" }}>{moment.utc(reply.createdtime).local().format('MM/DD/YYYY hh:mm A')}</span>
                                        </div>
                                    )) :
                                    null
                            }
                        </div>
                    </Modal.Body>
                </Modal>
                {this.state.modal ?
                    <Notes modal={this.state.modal} id={this.state.params.itemsId} name='item' hideNotes={this.hideNotes} data={this.state.itemsDetails} getNotesCount={this.getNotesCount} /> : ''
                }
                {this.state.changeBidderModal && <ChangeBidder itemsId={this.state.params.itemsId} token={this.state.buyerToken} show={this.state.changeBidderModal} closeModal={() => {
                    this.setState({ changeBidderModal: false })
                }} />}
                <Modal id="retractAll" centered show={this.state.retractAllModal} onHide={() => { this.setState({ ...this.state }) }}>
                    <div style={{ textAlign: "right", fontSize: 12, marginRight: '32px', marginBottom: '-22px', marginTop: '16px' }}> {this.state.additionalnotes.length}/250</div>
                    <div className="" style={{ width: "100%" }}>
                        <Form.Control as="textarea" name="additionalnotes" value={this.state.additionalnotes} style={{ display: "flex", height: '100px', width: '86%', marginLeft: '37px', marginTop: '28px', borderRadius: '0px' }} maxLength='250' placeholder="Please provide the reason for the retraction and keep in mind this message will be sent to all user who bid on this item." className="rowamount" onChange={this.handleChange} />
                    </div>
                    <Modal.Body className="pl-5 pb-4 pt-4 py-4">
                        <span style={{ fontSize: '1rem', paddingLeft: '26px' }}>This will retract <u>all bids</u>, would you like to proceed?</span>
                        <div className="mt-2">
                            <div className="d-flex flex-row justify-content-center text-center">
                                {
                                    this.state.retractStatus.show ?
                                        <ToasterMessage type={this.state.retractStatus.type} message={this.state.retractStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex flex-row justify-content-center text-center">
                                <Button className="btn-white mx-1" onClick={() => { this.setState({ retractAllModal: false }) }}>Cancel</Button>
                                <Button className="mx-1" variant="secondary" onClick={() => this.retractAll()} disabled={this.state.retractStatus.type === 'success' || !this.state.additionalnotes}>Confirm {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal id="retract" centered show={this.state.retractModal} onHide={() => { this.setState({ ...this.state }) }}>
                    <div className="" style={{ width: "100%" }}>
                        <div style={{ textAlign: "right", fontSize: 12, marginRight: '32px', marginBottom: '-22px', marginTop: '16px' }}> {this.state.retractnotes.length}/250</div>
                        <Form.Control as="textarea" value={this.state.retractnotes} name="retractnotes" style={{ display: "flex", height: '100px', width: '86%', marginLeft: '37px', marginTop: '28px', borderRadius: '0px' }} maxLength='250' placeholder="Please provide the reason for the retraction and keep in mind this message will be sent to all user who bid on this item." className="rowamount" onChange={this.handleRetractChange} />
                    </div>
                    <Modal.Body className="pl-4 pb-4 pt-4 py-4">
                        <span style={{ fontSize: '1rem', paddingLeft: '11px' }}>This will retract the<u> current bid</u>, would you like to proceed?</span>
                        <div className="mt-2">
                            <div className="d-flex flex-row justify-content-center text-center">
                                {
                                    this.state.retractStatus.show ?
                                        <ToasterMessage type={this.state.retractStatus.type} message={this.state.retractStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex flex-row justify-content-center text-center">
                                <Button className="btn-white mx-1" onClick={() => { this.setState({ retractModal: false, retractnotes: '' }) }}>Cancel</Button>
                                <Button className="mx-1" variant="secondary" onClick={() => this.retract(this.retractId)} disabled={this.state.retractStatus.type === 'success' || !this.state.retractnotes}>Confirm {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                {/* Selected Reteact Modal UI*/}
                <Modal centered show={this.state.selectedRetractModal} className="selectedretractModal" scrollable={true} onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Header>
                        <div className="w-100 d-flex justify-content-between">
                            <b>Bidder</b>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        {
                            this.state.nicknameList.map(Bidder =>
                                <div className="border-bottom">
                                    <div className="d-flex justify-content-between my-1 p-3">
                                        <b>{Bidder['nickname']}</b>
                                        <div className="custom-header-checkbox">
                                            <Form>
                                                <div className={`custom-checkbox-div ${this.state?.selectedNickname?.includes(Bidder.id) ? 'checked' : ''}`} onClick={() => this.onChangeRetractCheckBox(Bidder)}></div>
                                            </Form>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    </Modal.Body>
                    <Modal.Footer className="d-flex justify-content-end align-items-end">
                        <div className="d-flex">
                            <Button onClick={() => this.resetselectedRetractModal()} className="btn-white">Cancel</Button>
                            <Button onClick={() => this.showSelectedReasonModal()} disabled={this.state.selectedRetractList.length < 1} className="btn-secondary ml-2">Retract</Button>
                        </div>
                    </Modal.Footer>
                </Modal>

                {/* Retract reason Modal*/}
                <Modal id="retract" centered show={this.state.selectedretractModal} onHide={() => { this.setState({ ...this.state }) }}>
                    <div className="" style={{ width: "100%" }}>
                        <div style={{ textAlign: "right", fontSize: 12, marginRight: '32px', marginBottom: '-22px', marginTop: '16px' }}> {this.state.retractnotes.length}/250</div>
                        <Form.Control as="textarea" value={this.state.retractnotes} name="retractnotes" style={{ display: "flex", height: '100px', width: '86%', marginLeft: '37px', marginTop: '28px', borderRadius: '0px' }} maxLength='250' placeholder="Please provide the reason for the retraction and keep in mind this message will be sent to all user who bid on this item." className="rowamount" onChange={this.handleRetractChange} />
                    </div>
                    <Modal.Body className="pl-4 pb-4 pt-4 py-4">
                        <span style={{ fontSize: '1rem' }}>This will retract the<u> selected bidder's on this item</u>, would you like to proceed?</span>
                        <div className="mt-2">
                            <div className="d-flex flex-row justify-content-center text-center">
                                {
                                    this.state.retractStatus.show ?
                                        <ToasterMessage type={this.state.retractStatus.type} message={this.state.retractStatus.message} className="alert-handle mt-2"></ToasterMessage>
                                        : null
                                }
                            </div>
                            <div className="d-flex flex-row justify-content-center text-center">
                                <Button className="btn-white mx-1" onClick={() => { this.setState({ selectedretractModal: false, retractnotes: '' }) }}>Cancel</Button>
                                <Button className="mx-1" variant="secondary" onClick={() => this.Selectedretract(this.state.selectedRetractList)} disabled={this.state.retractStatus.type === 'success' || !this.state.retractnotes}>Confirm {' '} {this.state.loading ? <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> : null}</Button>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

            </div>
        );
    }
}

export default connect(state => state)(ItemsView);